/**
 * transition in
 * @param delay
 */
export function transitionIn(delay: number = 0)
{
    let element: HTMLElement;

    //  get the transition element

    element = document.getElementById('transition-overlay');

    //  show the transition

    setTimeout(() => element.classList.add('occluding'), delay);
}


/**
 * transition out
 */
export function transitionOut(delay: number = 0)
{
    let element: HTMLElement;

    //  get the transition element

    element = document.getElementById('transition-overlay');

    //  show the transition

    setTimeout(() => element.classList.remove('occluding'), delay);
}


// WEBPACK FOOTER //
// ./src/ts/screens/transition-overlay/TransitionOverlay.ts